import { mergeStyleSets, Modal } from "office-ui-fabric-react";
import React, { Component } from "react";
import { getTheme } from "office-ui-fabric-react";

export class EUIModal extends Component {

    static defaultProps = {
        buttons: [],
        isOpen: false,
        onDismiss: null,
        titre: "",
    };

    _theme = getTheme();

    _classNames = mergeStyleSets({
        container: {
            display: "flex",
            flexDirection: "column",
            height: "60vh",
            //maxHeight: "60vh",
            //maxWidth: "500px",
            width: "60vw"
        },
        scrollableContent: {
            display: "flex",
            flexDirection: "column"
        },
        header: {
            background: this._theme.palette.themePrimary,
            color: "white",
            padding: "8px 28px 0"
        },
        body: {
            flex: "2 2",
            overflowY: "auto",
            padding: "5px 28px"
        },
        footer: {
            display: "flex",
            gap: "8px",
            justifyContent: "right",
            padding: "15px 28px",
        }
    });

    render = () => {

        const { buttons, isOpen, onDismiss, titre } = this.props;

        return <Modal
            containerClassName={this._classNames.container}
            isOpen={isOpen}
            onDismiss={onDismiss}
            scrollableContentClassName={this._classNames.scrollableContent}
        >
            <div className={this._classNames.header}>
                <h3>{titre}</h3>
            </div>
            <div className={this._classNames.body}>
                {this.props.children}
            </div>
            <div className={this._classNames.footer}>
                {buttons}
            </div>
        </Modal>;

    }
}